/**
 * Enumération définissant les états de jobs.
 */
enum EtatJobEnum {
  EN_COURS = "En cours",
  TERMINE = "Terminé",
  NOTIFIE = "Notifié",
  EN_ERREUR = "En erreur",
}

export default EtatJobEnum;
